import { create } from 'zustand';

interface DemoTourState {
  touring: boolean;
  highlights: string[];
  trafficVisible: boolean;
  startTour: () => void;
  endTour: () => void;
  setHighlights: (ids: string[]) => void;
  setTrafficVisible: (v: boolean) => void;
}

export const useDemoTour = create<DemoTourState>((set) => ({
  touring: false,
  highlights: [],
  trafficVisible: true,
  startTour: () => set({ touring: true, highlights: [], trafficVisible: true }),
  endTour: () => set({ touring: false, highlights: [] }),
  setHighlights: (ids) => set({ highlights: ids }),
  setTrafficVisible: (v) => set({ trafficVisible: v }),
}));
